module.exports = __webpack_public_path__ + "img/sla-green.9486d41e.svg";